import React, { useState } from 'react';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'react-headless-accordion';
import { IoIosArrowBack } from 'react-icons/io';

const Accordion1 = ({ type }) => {
    const [rotationState, setRotationState] = useState(false);

    const toggleRotation = () => {
        setRotationState(!rotationState);
    };

    const accordionTransitionDuration = 500; // Set the same duration as the accordion transition

    const accordionClass = () => {
        switch (type) {
            case 'rounded':
                return 'max-w-[500px] mx-auto border-accordionBorderColor bg-gradient-to-r from-yellow-300 to-yellow-400 rounded-2xl border-[4px] shadow-lg';
            case 'rectangle':
                return 'max-w-[500px] mx-auto border-accordionBorderColor rounded-none bg-gradient-to-r from-accordionMainColor to-accordionSecondaryColor border-[4px] shadow-lg';
            default:
                return '';
        }
    };

    return (
        <div className='mt-6 mx-auto px-4'>
            <Accordion
                className={accordionClass()}
                transition={{ duration: `${accordionTransitionDuration}ms`, timingFunction: 'cubic-bezier(0, 0, 0.2, 1)' }}
            >
                <AccordionItem>
                    <AccordionHeader
                        className='bg-gradient-to-r from-yellow-300 to-yellow-400 items-center text-accordion_headerColor flex p-4 w-full justify-between rounded-2xl'
                        onClick={toggleRotation}
                    >
                        <IoIosArrowBack
                            className={`${rotationState ? 'rotate-90' : ''} text-2xl text-accordion_iconColor`}
                            style={{ transition: `transform 0.5s ease-in-out` }}
                        />
                        <h3 dir='rtl' className='text-2xl text-black font-bold'>האימון הצהוב 🐪</h3>
                    </AccordionHeader>

                    <AccordionBody>
                        <div dir='rtl' className='text-black text-right font-medium p-4  rounded-b-2xl'>

                            <div>
                                <p className='mt-2 font-bold text-xl'>
                                    אימון במדבר
                                </p>
                                <p dir='rtl'>
                                    ששם דגש על  יציבה נכונה  ומכיל מרכיבי  core ויציבה, למטרת שיפור  הגמישות והנשימה   דרך מיומנויות מעולם  ה core היוגה והפילאטיס.
                                </p>

                                <p className='mt-2 font-bold text-2xl'>
                                    שיפור  הגמישות והנשימה
                                </p>
                                <div className='border-[1px] border-black mt-2'>

                                </div>
                                <p className='mt-2 font-bold text-lg text-black'>
                                    סרטון האימון הצהוב:
                                </p>

                                <iframe
                                    src="https://www.youtube.com/embed/wVw7q4FT5n8"
                                    frameborder="0"
                                    height="350px"
                                    allow="autoplay; fullscreen"
                                    allowFullScreen
                                    style={{ borderRadius: '32px' }}
                                    className='my-4  w-full'
                                ></iframe>


                            </div>
                        </div>
                    </AccordionBody>
                </AccordionItem>
            </Accordion>
        </div>
    );
};

export default Accordion1;
